import { useEffect, useState } from 'react';

type Family = {
    id: string;
    family: string;
    name_a: string;
    name_b: string;
};

export default function FamiliesMetThisMonth() {
    const [families, setFamilies] = useState<Family[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFamilies = async () => {
            try {
                const response = await fetch('/api/families/met-this-month');
                if (!response.ok) throw new Error('שגיאה בטעינת משפחות');
                const data = await response.json();
                setFamilies(data);
            } catch (err) {
                console.error('❌ שגיאת רשת:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchFamilies();
    }, []);

    return (
        <div className="flex flex-col h-full w-full text-sm text-right leading-tight">
            <div className="text-green-800 font-bold text-center mb-1 whitespace-nowrap">
                משפחות שנפגשו החודש
            </div>

            <div className="flex-1 overflow-y-auto pr-1 space-y-1">
                {loading ? (
                    <div className="text-gray-600 text-center">טוען...</div>
                ) : families.length === 0 ? (
                    <div className="text-gray-600 text-center">אין פגישות</div>
                ) : (
                    families.map((f) => (
                        <div key={f.id} className="truncate">
                            <strong>{f.family}</strong>: {f.name_a} & {f.name_b}
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}

